/* global $ */

(function () {
  'use strict'

  // This should be a feature detection but I can't find one for it
  function supportsCssFilters () {
    return !('documentMode' in document)
  }

  $(function () {
    $('html').addClass(supportsCssFilters() ? 'cssfilter' : 'no-cssfilter')
  })
})()
